import { render } from "./ValueMetric.vue?vue&type=template&id=2922ae78"
import script from "./ValueMetric.vue?vue&type=script&lang=js"
export * from "./ValueMetric.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ValueMetric.vue"]])

export default __exports__